import ButtonWithLoading from 'mixs/inputs/button_with_loading';
import { AJAX_ACCECCING, AJAX_ACCECCED } from 'apps/events';
import TimeLag from 'utilities/timelag';
import { deepmerge } from 'utilities/merge';

class Submit extends ButtonWithLoading {
  defaultOpts = {
    align: 'left'
  }
  init(){
    this.opts = deepmerge(this.defaultOpts, this.opts)
    super.init();
  }
  beforeOnChangeStore(){
    let button = <HTMLButtonElement>this.querySelector('button')
    if(document.activeElement == button){
      button.blur();
    }
  }
  setDefaultOptions(){
    this.opts['klass'] = 'btn-primary';
  }
}

class SubmitDestroy extends Submit {
  setDefaultOptions(){
    this.opts['klass'] = 'btn-danger';
  }
}

riot.mixin("inputs.submit", Submit as riot.TagMixin)
riot.mixin("inputs.submit-destroy", SubmitDestroy as riot.TagMixin)
